import angular from 'angular';
import constants from 'app/constants';
import {
  amDataService,
  amSharedModelService,
  loaderService,
  ssDialogService,
} from 'app/services';
import { alerts } from 'app/components/global';
import saveFindingConfirmDialog from '../dialog.saveFindingConfirmDialog';
import controller from './edit-finding-dialog.controller';
import template from './edit-finding-dialog.html';

/**
 * Validators
 */
import validator1, { name as validatorName1 } from '../messages/finding-unique-name.validator.directive';
import validator2, { name as validatorName2 } from '../messages/finding-unique-reference-number.validator.directive';

/**
 * Templates
 */
import generalTextTpl from '../messages/finding.general-text.messages.html';
import referenceNumberTpl from '../messages/finding.reference-number.messages.html';
import nameTpl from '../messages/finding.name.messages.html';
import descriptionTpl from '../messages/finding.description.messages.html';
import assignedToTpl from '../messages/finding.assigned-to.messages.html';
import statusTpl from '../messages/finding.status.messages.html';
import businessRiskTpl from '../messages/finding.business-risk.messages.html';
import technicalRiskTpl from '../messages/finding.technical-risk.messages.html';
import priorityTpl from '../messages/finding.priority.messages.html';
import findingScoreTpl from '../messages/finding.finding-score.messages.html';
// finding.date.messages.html // <-- unused template

class dialogService {
  getOptions($event, {
    // eslint-disable-next-line max-len
    customerId, auditId, auditIsActive, businessRisks, technicalRisks, priorities, statuses, users, finding, addCallback,
  }) {
    return {
      controller,
      controllerAs: 'editFindingDialogVM',
      locals: {
        customerId,
        auditId,
        auditIsActive,
        businessRisks,
        technicalRisks,
        priorities,
        statuses,
        users,
        finding,
        addCallback,
      },
      escapeToClose: false,
      clickOutsideToClose: false,
      targetEvent: $event,
      template,
    };
  }
}

export default angular.module('app.components.advisory.auditTrail.editFindingDialog', [
  alerts,
  amDataService,
  amSharedModelService,
  constants,
  loaderService,
  saveFindingConfirmDialog,
  ssDialogService,
])
  .directive(validatorName1, validator1)
  .directive(validatorName2, validator2)
  .service('editFindingDialog', dialogService)
  .run(($templateCache) => {
    $templateCache.put('finding.name.messages.html', nameTpl);
    $templateCache.put('finding.general-text.messages.html', generalTextTpl);
    $templateCache.put('finding.description.messages.html', descriptionTpl);
    $templateCache.put('finding.assigned-to.messages.html', assignedToTpl);
    $templateCache.put('finding.status.messages.html', statusTpl);
    $templateCache.put('finding.business-risk.messages.html', businessRiskTpl);
    $templateCache.put('finding.technical-risk.messages.html', technicalRiskTpl);
    $templateCache.put('finding.priority.messages.html', priorityTpl);
    $templateCache.put('finding.finding-score.messages.html', findingScoreTpl);
    $templateCache.put('finding.reference-number.messages.html', referenceNumberTpl);
  })
  .name;
